// Px to rem conversion
export function px(p) {
  return `${Math.round(p) / 16}rem`;
}
